import React, { useState } from "react";
import { IconButton, TextField, Box, InputAdornment } from "@mui/material";
import { Controller } from "react-hook-form";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
const InputController = (props) => {
  const {
    control,
    errors,
    name,
    label,
    isSmall = false,
    size = "medium",
    isDisabled = false,
    isLoading,
    isGrow = false,
    isNumberField = false,
    isCustomError = false,
    mainLogin = false,
    comment,
    defaultheight=true,
  } = props;

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <TextField
           multiline={comment ? true : false}
          rows={comment ? 2 : undefined}
          sx={{ flexGrow: isGrow ? 1 : undefined,
            "& .MuiInputBase-root": {
              height: defaultheight ? undefined : !mainLogin && !comment ? "35px !important" : undefined,
            },
            "& .MuiInputBase-root input": {
              width: defaultheight? undefined:!mainLogin ? "fit-content !important" : undefined,
            },
            "& .MuiInputBase-input.Mui-disabled": {
              WebkitTextFillColor: (theme) => theme.palette.black.main,
            },
            "& .MuiInputLabel-root.Mui-disabled": {
              color: (theme) => theme.palette.black.main,
            }, }}
          disabled={isLoading || isDisabled}
          {...field}
          label={label}
          variant="outlined"
          size={size}
          fullWidth={!isSmall}
          onChange={(event) => {
            if (isNumberField) {
              const { value } = event.target;
              const reg = /^[0-9\b]+$/; // regex to allow numbers and backspace
              if (value === "" || reg.test(value)) {
                field.onChange(event);
              }
            } else {
              field.onChange(event);
            }
          }}
          error={errors[name] ? true : false}
          helperText={errors[name] ? errors[name].message : ""}
        />
      )}
    />
  );
};

export default InputController;

const InputControllerWithIcon = (props) => {
  const {
    control,
    errors,
    name,
    label,
    icon,
    isSmall = false,
    size = "medium",
    isDisabled = false,
    isNumberField = false,
  } = props;
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <TextField
          disabled={isDisabled}
          {...field}
          label={label}
          variant="outlined"
          size={size}
          fullWidth={!isSmall}
          placeholder={label}
          sx={{
            "& .MuiInputBase-input.Mui-disabled": {
              WebkitTextFillColor: (theme) => theme.palette.black.main,
            },
            "& .MuiInputLabel-root.Mui-disabled": {
              color: (theme) => theme.palette.black.main,
            },
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment
                position="start"
                sx={{ color: (theme) => theme.palette.black.main }}
              >
                {icon}
              </InputAdornment>
            ),
          }}
          error={errors[name] ? true : false}
          helperText={errors[name] ? errors[name].message : ""}
        />
      )}
    />
  );
};

const SimpleTextField = (props) => {
  const [fieldValue, setFieldValue] = useState("");
  const [dataAddded, setDataAdded] = useState(false);

  const {
    name,
    label,
    isSmall = false,
    size = "medium",
    isDisabled = false,
    setField,
    getValues,
    handleDeleteArr,
    currentField,
    isNumberField = false,
  } = props;
  return (
    <>
      <Box sx={{ display: "flex", gap: "2px" }}>
        <TextField
          id={name}
          label={label}
          value={fieldValue || getValues(name) || ""}
          size={size}
          fullWidth={!isSmall}
          disabled={!isDisabled}
          onChange={(e) => {
            setFieldValue && setFieldValue(e.target.value);
          }}
          sx={{
            "& .MuiInputBase-input.Mui-disabled": {
              WebkitTextFillColor: (theme) => theme.palette.black.main,
            },
            "& .MuiInputLabel-root.Mui-disabled": {
              color: (theme) => theme.palette.black.main,
            },
          }}
        />
        <IconButton
          onClick={() => {
            setField(name, fieldValue);
            setDataAdded(true);
          }}
          disabled={dataAddded}
        >
          <AddIcon
            sx={{ width: "16px", color: dataAddded ? "grey" : "green" }}
          />
        </IconButton>
        <IconButton
          onClick={() => {
            setField(name, "");
            handleDeleteArr(currentField);
          }}
        >
          <CloseIcon sx={{ width: "16px", color: "red" }} />
        </IconButton>
      </Box>
    </>
  );
};

export { InputControllerWithIcon, SimpleTextField };
